module.exports = __webpack_public_path__ + "static/media/whatsapp.5fb75cf4.svg";